import React, { useMemo } from 'react';
import { CollapsibleMenu } from './collapsible-menu';
import { KeyboardArrowDown, Speed } from '@mui/icons-material';
import { LoggedInUserPropType } from '@src/components/prop-types/user';
import { axios } from '@src/lib/axios';

const baseMerchantDashboardNavPages = [
    { id: 'your-listings', label: 'Your Listings', href: '/merchants/items' },
    { id: 'create-new-listing', label: 'Create New Listing', href: '/merchants/upload' },
    { id: 'quotes', label: 'Quotes', href: '/merchants/quotation/list' },
    { id: 'booked-tasks', label: 'Booked Tasks', href: '/merchants/order/history' },
    { id: 'resources', label: 'Resources', href: '/pages/tasker-resources' },
    {
        id: 'payment',
        label: 'Payment Dashboard',
        onClick: async () => {
            try {
                const { data } = await axios.get('/stripe/dashboard-link');
                window.open(data.url, '_blank');
            } catch (err) {
                location.href = '/users/onboard-step-2?error=Incomplete-Tasker-onboarding';
            }
        }
    },
    { id: 'account-activity', label: 'Account Activity', href: '/merchants/dashboard' }
];

// IDs of pages that should be disabled if user has no subscription
const subscriptionRequiredPages = ['create-new-listing'];

export function DashboardMenu({ user }) {
    const merchantDashboardNavPages = useMemo(() => {
        return baseMerchantDashboardNavPages.map(page => {
            if (!user?.hasSubscription && subscriptionRequiredPages.includes(page.id)) {
                return { ...page, disabled: true };
            }
            return page;
        });
    }, [user?.hasSubscription]);

    return (
        <CollapsibleMenu
            navPages={merchantDashboardNavPages}
            menuIcon={<Speed sx={{ fontSize: 32 }} style={{ color: 'white' }} />}
            desktopIcon={
                <>
                    Dashboard
                    <KeyboardArrowDown size={23} />
                </>
            }
            id='dashboard-menu'
            user={user}
        />
    );
}

DashboardMenu.propTypes = {
    user: LoggedInUserPropType
};
